var _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAuditorNotes = function SvgAuditorNotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 4.5,
    fill: "#053602",
    stroke: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 19.777v7.93c0 2.89 4.321 2.511 4.876 2.511h3.88M29.467 20.103v-4.628c0-4.378-1.02-5.475-5.127-5.475h-8.213C12.021 10 11 11.097 11 15.475M15.888 15.432h4.889M23.492 15.432h2.173M16.974 19.777h6.518"
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.978 23.872-3.845 3.846a1.339 1.339 0 0 0-.326.64l-.206 1.467c-.076.532.293.902.825.826l1.467-.207c.206-.032.5-.174.64-.326l3.846-3.845c.663-.663.978-1.434 0-2.412-.967-.966-1.738-.652-2.4.011Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.425 24.426a3.46 3.46 0 0 0 2.411 2.412"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 19.777v7.93c0 2.89 4.321 2.511 4.876 2.511h3.88M29.467 20.103v-4.628c0-4.378-1.02-5.475-5.127-5.475h-8.213C12.021 10 11 11.097 11 15.475M15.888 15.432h4.889M23.492 15.432h2.173M16.974 19.777h6.518"
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.978 23.872-3.845 3.846a1.339 1.339 0 0 0-.326.64l-.206 1.467c-.076.532.293.902.825.826l1.467-.207c.206-.032.5-.174.64-.326l3.846-3.845c.663-.663.978-1.434 0-2.412-.967-.966-1.738-.652-2.4.011Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.425 24.426a3.46 3.46 0 0 0 2.411 2.412"
  })))));
};
export default SvgAuditorNotes;